import type { FaireRetailerEntity } from "../../entity_types/retailer";

export const r_vywa5ks4ga: FaireRetailerEntity = {
  token: "r_vywa5ks4ga",
  type: "retailer",
  name: "Elsie Rose Boutique",
  themeTokens: [
    // v3 themes
    "arkansas-game-day-rituals",
    "the-faithful-mother-and-mini",
    "low-tox-ancestral-wellness",
    "effortless-layering-essentials",
    "clean-living-and-holistic-care",
    "fayetteville-game-day-glam",
    "faith-fun-and-mindful-play",
    "soft-knits-for-mom-and-mini",
    "the-organic-apothecary",
    "bespoke-and-custom-youth-apparel",
    "non-toxic-family-first-aid-v3",
    "elevated-everyday-layers",
    "holistic-apothecary-and-mineral-support",
    "clean-beauty-and-vitality",
    "pocket-sized-pure-wellness",
    "cozy-layering-essentials",
    "clean-and-green-essentials",
    "zero-waste-clean-beauty",
    "chic-on-the-go-accessories",
    "under-10-wellness-finds",
    "the-holistic-pantry",
    "elevated-occasion-wear-and-tailoring",
    // v2 themes (Notion) — disabled for v3 prototype
    // "modern-minimalist-totes",
    // "sweet-and-cozy-baby-accents",
    // "holistic-family-wellness",
    // "pure-plant-based-essentials",
    // "safe-and-non-toxic-kids",
    // "clean-beauty-discovery",
    // "versatile-pop-up-layers",
    // "artisanal-trial-kits",
    // "polished-and-professional-essentials",
    // "curated-holistic-wellness",
    // "small-treasures-and-youthful-joy",
    // "on-the-go-wellness-essentials",
    // "pocket-sized-protection-under-10",
    // "non-toxic-family-first-aid",
    // v1 themes (FLARE) — disabled for v3 prototype
    // "sleep-calm-stack",
    // "mama-baby-comfort",
    // "pop-up-outfit-builders",
  ],
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00Z",
    importedBy: "manual-v2-import",
  },
};
